import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/new-patients/NewPatientsPage.tsx");
